export default __webpack_public_path__ + "static/media/fantom-logo.6e607a3e.svg";